import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  connect() {
    this.element.addEventListener("input", this.clearError)
    this.element.addEventListener("change", this.clearError)
  }

  disconnect() {
    this.element.removeEventListener("input", this.clearError)
    this.element.removeEventListener("change", this.clearError)
  }

  private clearError = (event: Event) => {
    const target = event.target
    if (!(target instanceof HTMLInputElement ||
          target instanceof HTMLSelectElement ||
          target instanceof HTMLTextAreaElement)) return

    const field = target.closest(".tw-form__field")
    if (!field) return

    field.classList.remove("tw-form__field--error")

    const errorInput = field.querySelector(".tw-form__input--error")
    if (errorInput) errorInput.classList.remove("tw-form__input--error")

    field.querySelectorAll(".tw-form__error").forEach(div => div.remove())
  }
}
